import { BankAccountDetailSection } from "bankaccount/BankAccountDetailSection";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import BankAccountOptionsPanel from "./BankAccountOptionsPanel";
import { BankAccountActivityPanel } from "bankaccount/activity/BankAccountActivityPanel";

export const BankAccountDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.BankAccountDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <BankAccountDetailSection
            bankAccount={viewModel.bankAccount}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <BankAccountOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            existingBankAccount={viewModel.bankAccount}
          />
          <BankAccountActivityPanel
            bankaccountId={viewModel.bankAccount.bankAccountId}
            config={viewModel.activityPanelConfig}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}